import { useEffect, useState } from 'react'
import Loader from 'react-loaders'
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet'
import { useRef } from 'react'
import emailjs from '@emailjs/browser'
import AnimatedLetters from '../AnimatedLetters'
import './index.scss'

const Contact = () => {
  const [letterClass, setLetterClass] = useState('text-animate')
  const form = useRef()

  useEffect(() => {
    return setTimeout(() => {
      setLetterClass('text-animate-hover')
    }, 3000)
  }, [])

  const sendEmail = (e) => {
    e.preventDefault()

    emailjs
      .sendForm(
        'service_tqm2xgq',
        'template_khf5w7v',
        form.current,
        'Oziwnm_BGLNIGC3gX'
      )
      .then(
        () => {
          alert('Bingoo !! envoyé')
          window.location.reload(false)
        },
        () => {
          alert('email me : nassertbr@gmail.com')
        }
      )
  }

  return (
    <>
      <div className="container contact-page">
        <div className="text-zone">
          <h1>
            <AnimatedLetters
              letterClass={letterClass}
              strArray={['C', 'o', 'n', 't', 'a', 'c', 't', ' ', 'm', 'e']}
              idx={15}
            />
          </h1>
          <p>
            Le site n'est pas encore complet, je rajouterai des exemples de travaux que j'ai réalisé :)
            Si vous avez des questions n'hésitez pas !
          </p>
          <div className="contact-form">
            <form ref={form} onSubmit={sendEmail}>
              <ul>
                <li className="half">
                  <input placeholder="Nom" type="text" name="name" required />
                </li>
                <li className="half">
                  <input
                    placeholder="Email"
                    type="email"
                    name="email"
                    required
                  />
                </li>
                <li>
                  <input
                    placeholder="Sujet"
                    type="text"
                    name="sujet"
                    required
                  />
                </li>
                <li>
                  <textarea
                    placeholder="Message"
                    name="message"
                    required
                  ></textarea>
                </li>
                <li>
                  <input type="submit" className="flat-button" value="ENVOYER" />
                </li>
              </ul>
            </form>
          </div>
        </div>
        <div className="info-map">
          Nasser Tiberdani,
          <br />
          France,
          <br />
          26 Av du 6 Juin, 14000 <br />
          Caen, Calvados <br />
          <br />
          <span>nassertbr@gmail.com</span>
        </div>
        <div className="map-wrap">
          <MapContainer center={[49.181765944931755, -0.3571310469151191]} zoom={13}>
            <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
            <Marker position={[49.181765944931755, -0.3571310469151191]}>
              <Popup>Nasser vit ici, come over :)</Popup>
            </Marker>
          </MapContainer>
        </div>
      </div>
      <Loader type="pacman" />
    </>
  )
}

export default Contact
